
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      masterTl: {},
    }
  },
  //   mounted() {
  //     this.$nextTick(() => {
  //       this.masterTl = this.$gsap
  //         .timeline()
  //         .to(this.$refs['project-seal'], { scale: 150, duration: 0.8 }, 2)
  //         .to(
  //           this.$refs['project-seal'],
  //           { opacity: 0, duration: 0.8, zIndex: 0 },
  //           2.5
  //         )
  //         .progress(1)
  //     })
  //   },
  //   methods: {
  //     mouseOver() {
  //       this.masterTl.play()
  //     },
  //     mouseLeave() {
  //       this.masterTl.reverse()
  //     },
  //   },
}
